/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AreaOfInterestList = {
    type: 'array',
    contains: {
        type: 'AreaOfInterest',
    },
} as const;
